import React, { useState } from "react";
import { useParams } from "react-router-dom";

import {
  Typography,
  Stack,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getDownloadReport, setAdjustmentFee } from "../../services/reports";
import { useUserContext } from "../../context/userContext";

const TabHeader = ({ title, report }) => {
  const userRole = useUserContext();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [feeOpen, setFeeOpen] = useState(false);
  const [adjustmentParams, setAdjustmentParams] = useState({
    merchant: report.merchant.id,
    payment_host: report.payment_host.id,
    adjustment_amount: "",
    reason: "",
    other_reason: "",
  });

  const listOfReasons = ["Reason 1", "Reason 2", "Reason 3", "Other"];

  const handleChange = (prop) => (event) => {
    setAdjustmentParams({ ...adjustmentParams, [prop]: event.target.value });
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const { id } = useParams();

  const handleDownloadCSV = () => {
    getDownloadReport(
      id,
      report.merchant?.name,
      report.report_number,
      report.report_date
    );
  };

  const postAdjustmentFee = () => {
    let props = {
      ...adjustmentParams,
      message:
        adjustmentParams.reason === "Other"
          ? adjustmentParams.other_reason
          : adjustmentParams.reason,
    };
    setAdjustmentFee(props);
    setFeeOpen(false);
    setAdjustmentParams({});
  };

  const hidden = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Stack
      direction="row"
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <Typography variant="h3" sx={{ mb: 5 }}>
        {title}
      </Typography>

      {!hidden && (
        <Stack direction={{ xs: "column", sm: "row" }}>
          {userRole?.report?.includes("Adjustment") && (
            <Button
              variant="outlined"
              sx={{
                height: "40px",
                textAlign: "center",
                marginRight: 3,
              }}
              onClick={() => setFeeOpen(true)}
            >
              Adjustment Fee
            </Button>
          )}
          <Button
            variant="outlined"
            sx={{
              height: "40px",
              textAlign: "center",
            }}
            // onClick={handleDialogOpen}
            onClick={handleDownloadCSV}
          >
            Download Report
          </Button>
        </Stack>
      )}

      <Dialog open={isDialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Download Report As:</DialogTitle>
        <DialogContent>
          <Stack direction="column">
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Button onClick={handleDownloadCSV}>XLSX</Button>
              <Button onClick={handleDownloadCSV} disabled>
                PDF
              </Button>
              <Button onClick={handleDownloadCSV} disabled>
                Email
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>

      <Dialog
        open={feeOpen}
        onClose={() => setFeeOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Edit Adjustment Fee</DialogTitle>
        <DialogContent
          sx={{
            "& .MuiTextField-root": { marginY: 1 },
          }}
        >
          <Stack direction="column">
            <Stack
              direction="row"
              justifyContent={"space-between"}
              sx={{ margin: 0 }}
            >
              <TextField
                value={adjustmentParams.adjustment_amount}
                onChange={handleChange("adjustment_amount")}
                label="Amount"
                type="number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                sx={{ width: "15ch" }}
              />
              <TextField
                select
                value={adjustmentParams.reason || ""}
                onChange={handleChange("reason")}
                label="Reason"
                required
                fullWidth
                sx={{ marginLeft: 2 }}
              >
                {listOfReasons.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Stack>

            {adjustmentParams.reason === "Other" && (
              <TextField
                value={adjustmentParams.other_reason}
                onChange={handleChange("other_reason")}
                label="Other reason"
                required
                multiline
                rows={2}
                fullWidth
              />
            )}
          </Stack>

          <Stack direction="row" sx={{ marginTop: 2 }}>
            <Button
              onClick={() => {
                setAdjustmentParams("");
                setFeeOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button onClick={postAdjustmentFee}>Submit</Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Stack>
  );
};

export default TabHeader;
